var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-0 py-0",attrs:{"fluid":"","no-gutters":""}},[_c('filters',{attrs:{"cup":true},on:{"getScheduleByLeague":_vm.getByFilters,"getByFilters":_vm.getByFilters,"getCupState":_vm.getCupState,"clear":_vm.clearData}}),_c('schedule-match-center',{attrs:{"matches":_vm.matches,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }